// features/Auth/stores/auth-store.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Role = "coach" | "athlete";

export interface BaseUser {
  uid: string;
  email: string;
  role: Role;
  name: string;
}

// It think its ok to store the BaseUser in the store as should not need updating from server
interface AuthState {
  // Basic auth state - minimal info needed
  baseUser: BaseUser | null;
  loading: boolean;
  error: string | null;

  // Actions
  setUser: (user: BaseUser | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
}

// This store only handles authentication state
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      baseUser: null,
      loading: false,
      error: null,

      setUser: (user) => {
        console.log("[auth-store] setUser called", {
          hasUser: !!user,
          uid: user?.uid,
          email: user?.email,
          name: user?.name,
          role: user?.role,
        });
        set({ baseUser: user, loading: false });
      },
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error, loading: false }),
      logout: () => set({ baseUser: null, loading: false, error: null }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ baseUser: state.baseUser }),
    },
  ),
);

// Simplified auth hook that only deals with basic user authentication
export const useAuth = () => {
  const store = useAuthStore();

  return {
    // Current user info - just the basics
    user: store.baseUser,
    isAuthenticated: !!store.baseUser,
    role: store.baseUser?.role,
    loading: store.loading,
    error: store.error,

    // Actions
    setUser: store.setUser,
    logout: store.logout,
  };
};
